import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { Ortak } from './../../../providers/ortak';
import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';



@Component({
  selector: 'page-kalem-onayla',
  templateUrl: 'kalem-onayla.html',
})
export class KalemOnaylaPage {
  Siparis: any = {
    StokKartID: "", CariKartID: "", IslemTuru: "", KdvOran: "", UrunAdi: "",
    IskontoOran1: "", IskontoOran2: "", IskontoOran3: "", IskontoTutar: "", IskontoluBirimFiyat: "",
    Tutar: "", NetFiyat: "", Miktar: "", BirimFiyat: ""
  };
  tip: number = 0;

  stokbilgisi: any = {};
  aktifkullaniciadi = "";
  constructor(public navCtrl: NavController,
    public ortak: Ortak,
    public toast: ToastController,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("Siparis") != null) {
      this.Siparis = navParams.get("Siparis");
    }
    if (navParams.get("Stok") != null) {
      this.stokbilgisi = navParams.get("Stok");
    }
    if (navParams.get("tip") != null) {//tip 1 satisfiyatı
      this.tip = navParams.get("tip");
      if (this.tip == 1) {
        this.Siparis.BirimFiyat = this.stokbilgisi.Price2;
      }
      if (this.tip == 2) { //tip 2 alisfiyatı
        this.Siparis.BirimFiyat = this.stokbilgisi.Price1;
      }
    }
    this.aktifkullaniciadi = this.ortak.storagePersonelGetir.Name;
  }


  KalemEkle() {
    this.Siparis.Tutar = this.Siparis.BirimFiyat * this.Siparis.Miktar;
    this.Siparis.NetFiyat = this.Siparis.BirimFiyat * this.Siparis.Miktar;
    var bllSiparisDetay = new BllSiparisDetay();
    bllSiparisDetay.satisfaturasiDetayEkle_Temp(this.Siparis.StokKartID, this.Siparis.CariKartID, this.Siparis.Miktar, this.Siparis.BirimFiyat, this.Siparis.Tutar,
      this.Siparis.KdvOran, this.Siparis.NetFiyat, -1, this.Siparis.UrunAdi, 255, this.aktifkullaniciadi).then(a => {
        this.presentToast(this.Siparis.UrunAdi + " " + "Eklendi");
        this.kapat();
      })
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      position: 'top'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/kalem-onayla/kalem-onayla.ts